export default __webpack_public_path__ + "static/media/ent.1f4b9d17.png";